import ColorHelper from "@/services/ColorHelper";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class GetColorMixin extends Vue {
  getColor(id: string): string {
    return ColorHelper.pickForKey(id);
  }
}
